import React, { ChangeEvent, useState } from "react";
import PageTitle from "../../shared/PageTitle";
import { useEffect } from "react";
import { ActionTypes } from "../../redux/ActionTypes";
import { useDispatch } from "react-redux";
import { BlankString, HTTPStatusCodes, HttpRequestMethods, MenuId } from "../../Constants";
import { useNavigate } from "react-router-dom";
import IVideo from "./models/interfaces/IVideo";
import { GetData } from "../../helpers/Fetch";
import { GetAccessToken } from "../../helpers/Functions";

const Videos = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [videos, setVideos] = useState<IVideo[]>([]);
  const [formSearchText, setFormSearchText] = useState<string>(BlankString);

  const GetAllVidoes = () => {
    GetData(BlankString, HttpRequestMethods.GET, "TrainingVideos", GetAccessToken()).then(response => {
      if (response.statusCode === HTTPStatusCodes.OK){
        setVideos(response.data);
      }
    })
  }

  const toPrettyDate = (rawDateStr : string | undefined) => {
    if(rawDateStr){
    const date = new Date(rawDateStr);
    return date.toLocaleDateString('en-US');
    }
    else 
      return BlankString;
  }

  useEffect(() => {
    dispatch({ type: ActionTypes.SET_ACTIVE_LINK, payload: MenuId.TRAINING_VIDEOS });
    GetAllVidoes();
  }, []);

  function handleSearchText(event: any): void {
        const searchString = event.target.value;
    if (event.target.name === "form_search") {
      setFormSearchText(event.target.value);
      const filteredForms = videos.filter((video) => {
        if (video.title.toLowerCase().includes(searchString.toLowerCase()) || video.trainers.toLowerCase().includes(searchString.toLowerCase())) {
          return video;
        }
      });
      if (searchString)
        setVideos(filteredForms);
  }
}

  return (
    <>
      <PageTitle title="Training Videos" />             
      <div className="container gp-container">
        <div className="row">
        <button onClick={() => navigate(`/Videos/New`)} style={{ cursor: "pointer" }} > + New Video</button>
          <div className="col-md-12">
          <div className="row" style={{ marginTop: 10 }}>
            <div className="has-feedback has-search">
              <span className="form-control-feedback"><i className="fa fa-search" aria-hidden="true"></i></span>
              <input type="text" name="form_search" className="form-control" placeholder="Search Videos" value={formSearchText} onChange={handleSearchText} />
            </div>
            <table className="table table-striped table-hover table-custom-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Training Topics</th>
                    <th>Trainer</th>
                    <th>YouTube Link</th>
                    <th>Training Date</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    videos.map(video => (
                      <tr key={video.id}>
                      <td>{video.id}</td>
                      <td>{video.title.split(';').map((part, idx) => (<div key={idx}>{part.trim()}</div>))}</td>
                      <td>{video.trainers}</td>
                      <td><a href={video.link} target="_blank" rel="noreferrer"><button>Click</button></a></td>
                      <td>{toPrettyDate(video.training_date)}</td>
                    </tr>

                    ))
                  }
                    {/* <>

                      <tr>
                        <td>012024</td>
                        <td>– Power of Making a List – Scripts and Contacts <br/>
                        – Initial First Presentation</td>
                        <td>Faro Amiri</td>
                        <td><a href="https://youtu.be/-1DIZ96Ea_M" target="_blank" rel="noreferrer"><button>Click</button></a></td>
                        <td>January 20,2024</td>
                      </tr>
                      <tr>
                        <td>011324</td>
                        <td>– Annual Event Updates What Comes with Owning a Business Level of Commitment and Expectations <br/>
                        – Selling the Dream vs. Selling the Reality</td>
                        <td>Faro Amiri</td>
                        <td><a href="https://youtu.be/5m0asuD42WU" target="_blank" rel="noreferrer"><button>Click</button></a></td>
                        <td>January 13,2024</td>
                      </tr>
                      <tr>
                        <td>010624</td>
                        <td> – Our 2024 Goals <br/>– Annual Event Update</td>
                        <td>Shon Killman</td>
                        <td><a href="https://youtu.be/_GlTpzNheB0" target="_blank"><button>Click</button></a></td>
                        <td>January 6, 2024</td>
                      </tr>
                      <tr>
                      <td>121623</td>
                        <td>– Planning Your Success in 2024</td>
                        <td>Faro Amiri</td>
                        <td><a href="https://youtu.be/ZjpKt6eG3is" target="_blank"><button>Click</button></a></td>
                        <td>December 16, 2023</td>
                      </tr>
                      <tr>
                      <td>120923</td>
                        <td>- Recruiting 101 <br />– Recruiting Part Two</td>
                        <td>Faro Amiri</td>
                        <td><a href="https://youtu.be/pBNw17pbrzY" target="_blank"><button>Click</button></a></td>
                        <td>December 9, 2023</td>
                      </tr>
                      <tr>
                      <td>120223</td>
                        <td>– Allianz Split Dollar Agreement w/Jacob <br />– Holiday Party Dec. 16th, Irvine, CA, Faro is Focusing on Recruiting till the GPFA Annual Event </td>
                        <td>Faro Amiri</td>
                        <td><a href="https://youtu.be/LNq2nCC55No" target="_blank"><button>Click</button></a></td>
                        <td>December 2, 2023</td>
                      </tr>
                      </>
                    
                    // users.map(user => (
                    //   <tr key={user.sid} onClick={() => navigate(`/Agents/${user.sid}`)} style={{ cursor: "pointer" }}>
                    //     <td>{user.sid}</td>
                    //     <td>{user.fname} {user.lname}</td>
                    //     <td>{user.lic_states}</td>
                    //     <td>{user.upline}</td>
                    //     <td>{user.email}</td>
                    //     <td>{user.contact_no}</td>
                    //     <td>{user.level}</td>
                    //     <td><span title="Agent Profile"><FontAwesomeIcon icon={solid("user")} /></span></td>
                    //   </tr>
                    // ))
                  } */}
                </tbody>
              </table>
        </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Videos;